import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useNavigate, useParams } from 'react-router'

import { FALLBACK_LANGUAGE } from '@app/i18n'

import { isValidLocale, localizeUrl } from './utils'

export function LocaleLayout () {
  const { locale } = useParams<{ locale: string }>()
  const { i18n } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!locale || !isValidLocale(locale)) {
      const pathWithoutInvalidLocale = window.location.pathname.replace(/^\/[^/]+(?=\/|$)/, '') || '/'
      navigate(
        localizeUrl(pathWithoutInvalidLocale + window.location.search + window.location.hash, FALLBACK_LANGUAGE),
        { replace: true },
      )
      return
    }

    if (i18n.language !== locale) {
      i18n.changeLanguage(locale)
    }
  }, [ locale, i18n, navigate ])

  if (!locale || !isValidLocale(locale)) {
    return null
  }

  return <Outlet />
}
